import { render, staticRenderFns } from "./place_on_ramp.vue?vue&type=template&id=5941fc14"
import script from "./place_on_ramp.vue?vue&type=script&lang=js"
export * from "./place_on_ramp.vue?vue&type=script&lang=js"
import style0 from "./place_on_ramp.vue?vue&type=style&index=0&id=5941fc14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports